var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',_vm._l((_vm.section.detail.items),function(item){return _c('div',{key:item.key,staticClass:"container"},[_c('h4',[_vm._v(_vm._s(item.name))]),_c('a',{attrs:{"href":item.links[0].url}},[_vm._v(" "+_vm._s(item.links[0].name)+" "),_c('svg',[_c('use',_vm._b({},'use',{'xlink:href':'#home-arrow-blue'},false))])])])}),0)
}
var staticRenderFns = []

export { render, staticRenderFns }